import { useState } from "react";

import GenerelSettingList from "../Components/List/GenerelSettingList";
import GeneralSettingForm from "../Components/Form/GeneralSettingForm";
import { MdCreateNewFolder } from "react-icons/md";
import { IoIosListBox } from "react-icons/io";

function GeneralSettingPage(data) {
  const [view, setView] = useState(true);
  const [editId, setEditId] = useState(null);

  const viewHadler = (i) => {
    setView(i);
    setEditId(null);
  };

  const handleEdit = (id) => {
    setEditId(id);
    setView(false);
  };

  return (
    <div className="my-5 container-fluid">
      <div className="row">
        <div className="col-sm-6">
          <p className="f-18 text-primary pb-2 border-bottom border-primary">
            General setting
          </p>
        </div>
        <div className="col-sm-6 d-flex justify-content-end">
          <div>
            <button
              onClick={() => viewHadler(true)}
              className="btn btn-info shadow-sm text-white mx-2"
            >
              <IoIosListBox className="fs-5" />
            </button>
            {/* <button
              onClick={() => viewHadler(false)}
              className="btn btn-info shadow-sm text-white mx-2"
            >
              <MdCreateNewFolder className="fs-5" />
            </button> */}
          </div>
        </div>
      </div>
      {!view && (
        <GeneralSettingForm
          data={data}
          editId={editId}
          onSuccessCreated={viewHadler}
        />
      )}
      {view && <GenerelSettingList onEdit={handleEdit} />}
    </div>
  );
}

export default GeneralSettingPage;
